export default __webpack_public_path__ + "static/media/265900F8-2006-47CA-AB6F-D24AEFB86F62_1_105_c.5168be4e.jpeg";